import React, { useEffect, useState } from 'react'
import Proptypes from 'prop-types'
import Layout from '../../../layout/layout'
import AddCustomer from './create-customer/customer-modal.component'
import styles from './customer-management.module.css'
import CustomerView, {
  CustomerViewContext,
} from '../customer-info-view/customerView'
import SpeedDials from '../customer-actions/index'
import CustomerList from '../customerList/customerList.component'
import CustomerSettings from '../customerSettings/customerSettings.component'
import CustomerHierarchy from '../customerHierarchy/customerHierarchy.component'

export default function CustomerManagement({ fromHierarchy }) {
  console.log('fh: ', fromHierarchy)
  const [viewCustomer, setViewCustomer] = useState(false)
  const [viewNetworkSettings, setViewNetworkSettings] = useState(false)
  const [viewHierarchy, setViewHierarchy] = useState(false)
  const [customerData, setCustomerData] = useState(false)
  const [customerSettings, setCustomerSettings] = useState({})
  const [show, setShow] = useState(false)
  const [openTemplateDialog, setOpenTemplateDialog] = useState(false)
  const [showConfirmDialog, setShowConfirmDialog] = useState(false)
  const [showDeviceBulk, setDeviceBulkShow] = useState(false)

  useEffect(() => {
    setViewCustomer(false)
  }, [])

  const renderView = () => {
    if (viewCustomer) {
      return <CustomerView />
    }

    if (viewNetworkSettings) {
      return <CustomerSettings />
    }

    if (viewHierarchy) {
      return <CustomerHierarchy />
    }

    return (
      <>
        <CustomerList className={styles.list} fromHierarchy={fromHierarchy} />
        <SpeedDials show={show} setShow={setShow} />
        <AddCustomer show={show} setShow={setShow} className={styles.actions} />
      </>
    )
  }

  return (
    <Layout>
      <CustomerViewContext.Provider
        value={{
          viewCustomer,
          setViewCustomer,
          customerData,
          setCustomerData,
          openTemplateDialog,
          showDeviceBulk,
          setDeviceBulkShow,
          setOpenTemplateDialog,
          showConfirmDialog,
          setShowConfirmDialog,
          setViewNetworkSettings,
          setCustomerSettings,
          customerSettings,
          viewHierarchy,
          setViewHierarchy,
        }}
      >
        <div className={styles.container}>{renderView()}</div>
      </CustomerViewContext.Provider>
    </Layout>
  )
}

CustomerManagement.propTypes = {
  fromHierarchy: Proptypes.bool,
}
